module.exports = __webpack_public_path__ + "images/pages/for_business/pc/sec11_f93eb2a732ae8f62fa06597a63a7fbc3.jpg";